import Request from '@/utils/request'

// 提现之前 验证check 最近7天违规
export const apiWithdrawCheck = (walletType, data) => {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/pre/check`,
    method: 'post',
    data,
  })
}

// 获取check 数据
export const apiWithdrawCheckData = (walletType, params) => {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/pre/check/cfg`,
    method: 'get',
    params,
  })
}

// 新年提示 在规定时间内显示
export const apiNewyearDiaShowTime = (data) => {
  return Request({
    url: '/api/v2/app/withdraw/wallet/holiday/notification',
    method: 'post',
    data,
  })
}
